import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { map } from 'rxjs';

/** Ekrany przed zalogowaniem: zalogowany klient idzie na stronę główną. */
export const NoAuthGuard: CanActivateFn | CanActivateChildFn = () => {
    const router: Router = inject(Router);

    return inject(AuthService)
        .check()
        .pipe(map((session) => (session === 'ok' ? router.parseUrl('') : true)));
};
